import { render, staticRenderFns } from "./ResearcherAffiliations.vue?vue&type=template&id=5aa70919&scoped=true&"
import script from "./ResearcherAffiliations.vue?vue&type=script&lang=js&"
export * from "./ResearcherAffiliations.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherAffiliations.vue?vue&type=style&index=0&id=5aa70919&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa70919",
  null
  
)

export default component.exports